import { render } from "./TournamentPlayers.vue?vue&type=template&id=008e61ba"
import script from "./TournamentPlayers.vue?vue&type=script&lang=js"
export * from "./TournamentPlayers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__